import { useWalletModal } from './WalletModalContext';
import { useChat } from '../context/ChatContext';
import '../styles/EverythingSection.css';

const CARDS = [
  {
    id: 'fxrp-staking',
    title: 'SYNCHRONIZATION ',
    body: 'Troubleshoot and Resolve wallet sync issues to ensure accurate, real-time balance display across supported chains.',
    button: 'Sync Wallet',
  },
  {
    id: 'start-building',
    title: 'WALLET CONNECTION ISSUES',
    body: 'Connection rejected, unsupported wallet, wrong network, or the app is not detecting your account.',
    button: 'Fix Connection',
  },
  {
    id: 'careers',
    title: 'TRANSACTION ISSUES',
    body: 'Find and resolve failed, pending, or out-of-gas transactions. Have the tx hash ID ready.',
    button: 'Fix Transaction',
  },
  {
    id: 'newsletter',
    title: 'TOKEN BALANCE MISSING',
    body: 'Token is on-chain but not reflecting in the wallet, wrong network selected, or a custom token that needs the contract address added.',
    button: 'Find Token',
  },
  {
    id: 'whitepapers',
    title: 'ACTIVATE SMART ACCOUNT',
    body: 'Enable Flare Smart Accounts (FSA) on a supported wallet to authorize FXRP minting and Flare DeFi actions with one signature from your existing account.',
    button: 'Activate Smart Account',
  },
  {
    id: 'developer-hub',
    title: 'STAKING ISSUES',
    body: 'Rewards not showing, stake failed, or a lock/unstake that did not complete.',
    button: 'Fix Staking',
  },
  {
    id: 'system-explorer',
    title: 'CLAIM ISSUES',
    body: 'Unable to claim staking, FTSO, farm, or vault rewards that are due.',
    button: 'Fix Claim',
  },
  {
    id: 'flare-portal',
    title: 'SWAP ISSUES',
    body: 'Failed, pending, or stuck swaps on all Flare DEXs, including routing errors and slippage.',
    button: 'Fix Swap',
  },
  {
    id: 'flare-block-explorer',
    title: 'FASSETS TROUBLESHOOTING',
    body: 'Mint errors, failed redemptions, wrong FXRP balances, or tokens not showing after a completed mint.',
    button: 'Fix FAssets issues',
  },
  {
    id: 'connect',
    title: 'RPC FIRMWARE MANAGEMENT',
    body: 'Apply the latest firmware updates to your wallet to maintain security and ensure compatibility with Flare RPC endpoints.',
    button: 'Update Firmware',
  },
  {
    id: 'build',
    title: 'XRP FLAREDROP & REWARDS',
    body: 'Access your accumulated Flare token distribution allocated to XRP holdAs ers based on the official snapshot taken in December 2020.',
    button: 'Claim Airdrop',
  },
  {
    id: 'update',
    title: 'REVOKE TOKEN PERMISSION',
    body: 'Manage and revoke smart-contract permissions from dApps you no longer use to regain control over token access and minimize exposure risks..',
    button: 'Revoke Access',
  },
  {
    id: 'fasset',
    title: 'ASSET RECOVERY',
    body: 'Located and restore lost, inaccessible or unidexed digital assets using guided tooks and protocol level validation.',
    button: 'Recover Assets',
  },
];

function Card({ card, onOpen }) {
  return (
    <div className="everything-card">
      <h3 className="everything-card__title">{card.title}</h3>
      <p className="everything-card__body">{card.body}</p>
      <button className="everything-card__btn" onClick={onOpen}>
        {card.button}
      </button>
    </div>
  );
}

function EverythingSection() {
  const { open: openWalletModal } = useWalletModal();
  const { open: openChat } = useChat();

  return (
    <section className="everything">
      <h2 className="everything__title">Need help? Select a category below to diagnose and resolve your issue with the support team.</h2>
      <div className="everything__grid">
        {CARDS.map((card) => (
          <Card key={card.id} card={card} onOpen={openWalletModal} />
        ))}
      </div>

      <div className="everything__help">
        <h3 className="everything__help-title">Need Help Choosing?</h3>
        <p className="everything__help-body">
          Start a live chat and our support team will guide you to the right solution.
        </p>
        <button className="everything__help-btn" onClick={openChat}>
          💬 Start Live Chat
        </button>
      </div>
    </section>
  );
}

export default EverythingSection;